// import: styles
import { Box } from '@mui/material';

// import: assets
import { ReactComponent as Desktop } from 'core/assets/svg/best-viewed-on-desktop/desktop.svg';

// import: components
import BaseTypography from 'core/components/typography/BaseTypography';
import { bestViewedOnDesktopStyles } from 'core/layouts/components/best-viewed-on-desktop/BestViewedOnDesktopStyles';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
import React from 'react';

// import: constants
// import: utils
// import: services
// import: redux
// import: components
// import: lazy load components

function BestViewedOnDesktop() {
	return (
		<Box
			id="best-viewed-on-desktop"
			sx={[reusableStyles.flexCol, bestViewedOnDesktopStyles.bestOnDesktopBannerWrapper]}
		>
			<Box sx={[reusableStyles.mobileOnly, bestViewedOnDesktopStyles.bestOnDesktopBanner]}>
				<Box sx={[reusableStyles.flexRow, { gap: '6px' }]}>
					<Desktop />
					<BaseTypography variant="body1" styles={{ color: 'colors.light2' }}>
						Best viewed on desktop
					</BaseTypography>
				</Box>
			</Box>
		</Box>
	);
}

export default BestViewedOnDesktop;
